import { render, staticRenderFns } from "./AS_ProjectSideNav.vue?vue&type=template&id=f8155712&scoped=true&"
import script from "./AS_ProjectSideNav.vue?vue&type=script&lang=js&"
export * from "./AS_ProjectSideNav.vue?vue&type=script&lang=js&"
import style0 from "./AS_ProjectSideNav.vue?vue&type=style&index=0&id=f8155712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8155712",
  null
  
)

export default component.exports